'use client';

import type { Config } from '@shared/utils';
import { createContext, useContext, type ReactNode } from 'react';

const ClientConfigContext = createContext<Config | null>(null);

type ClientSideConfigProviderProps = {
  config: Config;
  children: ReactNode;
};

function ClientSideConfigProvider({ config, children }: ClientSideConfigProviderProps) {
  return <ClientConfigContext.Provider value={config}>{children}</ClientConfigContext.Provider>;
}

function useClientConfig() {
  const context = useContext(ClientConfigContext);

  if (context === null) {
    throw new Error('useClientConfig must be used within a ClientSideConfigProvider');
  }

  return context;
}

export { ClientSideConfigProvider, useClientConfig };
